module.exports = __webpack_public_path__ + "img/audiopause.a2454dd2.png";